import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import PsfSalesCard from "./PsfSalesCard";
import PsfServiceCard from "./PsfServiceCard";

const CustomerMetricsAccordian = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="  flex justify-between items-center bg-blue-300 rounded-md p-2">
        <p className="text-white text-center w-full font-semibold">
          Customer Experience Metrics
        </p>
        <div
          className="p-1 rounded-md bg-blue-400 hover:bg-blue-500 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <IoIosArrowDown
            className={`transition-transform duration-300 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        </div>
      </div>

      {isOpen && (
        <div className="mt-2 block sm:flex sm:flex-col md:flex-row lg:flex-row gap-4 items-center justify-center w-full">
          <PsfSalesCard />
          <PsfServiceCard />
        </div>
      )}
    </div>
  );
};

export default CustomerMetricsAccordian;
